import './FileDropArea.scss';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { SonarText } from '@ui/text';
import { useDropzone } from 'react-dropzone';
import { Case, Default, Switch } from 'react-if';
import { CheckCircleOutlined, CloseCircleOutlined, InboxOutlined } from '@ant-design/icons';
import React, { memo, useEffect } from 'react';
const defaultMaxSize = 5242880;
const defaultImageAccept = {
    'image/*': []
};
export const FileDropArea = memo(({ accept = defaultImageAccept, maxSize = defaultMaxSize, minSize = 0, multiple = false, onAccept, unsupportedMessage = COPY_SPECIFIC.UNSUPPORTED_FILE_TYPE_GENERIC }) => {
    const { acceptedFiles, isDragActive, isDragAccept, isDragReject, fileRejections, getRootProps, getInputProps } = useDropzone({
        accept,
        maxSize,
        minSize,
        multiple
    });
    useEffect(() => {
        if (acceptedFiles === null || acceptedFiles === void 0 ? void 0 : acceptedFiles.length) {
            onAccept(acceptedFiles);
        }
    }, [acceptedFiles, onAccept]);
    const isFileTooLarge = fileRejections.length > 0 && fileRejections[0].file.size > maxSize;
    let message = COPY_SPECIFIC.CLICK_OR_DRAG_FILE_TO_THIS_AREA_TO_UPLOAD;
    if (isDragReject) {
        message = unsupportedMessage;
    }
    if (isFileTooLarge) {
        message = COPY_SPECIFIC.FILE_IS_TOO_LARGE(maxSize);
    }
    const isInvalid = (isDragActive && isDragReject) || (!isDragActive && isFileTooLarge);
    const isValid = isDragActive && isDragAccept;
    const iconClassNames = classNames('upload-icon', {
        invalid: isInvalid,
        valid: isValid
    });
    return (React.createElement("section", Object.assign({}, getRootProps({ className: 'file-drop-area' })),
        React.createElement("input", Object.assign({}, getInputProps())),
        React.createElement("span", { className: iconClassNames },
            React.createElement(Switch, null,
                React.createElement(Case, { condition: isInvalid },
                    React.createElement(CloseCircleOutlined, null)),
                React.createElement(Case, { condition: isValid },
                    React.createElement(CheckCircleOutlined, null)),
                React.createElement(Default, null,
                    React.createElement(InboxOutlined, null)))),
        React.createElement(SonarText, { size: 16 }, message)));
});
